import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import React from "react";

const Youtube: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
            {props.title && <title>{props.title}</title>}
            <path
                fill="#fff"
                d="M17.288 14.436l-3.437-1.604c-.3-.14-.546.017-.546.349v3.02c0 .333.246.49.546.35l3.436-1.604c.301-.14.301-.37.001-.511zM14.835 0C6.721 0 .144 6.577.144 14.691S6.72 29.383 14.835 29.383s14.691-6.578 14.691-14.692S22.95 0 14.835 0zm0 20.66c-7.52 0-7.652-.678-7.652-5.969 0-5.29.132-5.968 7.652-5.968 7.52 0 7.652.678 7.652 5.968s-.132 5.969-7.652 5.969z"
            ></path>
        </svg>
    );
};

export default React.memo(Youtube);
